var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportNodeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L15.2527 9.23703C13.8592 7.8311 13.1625 7.12813 12.3133 7.01989C12.1053 6.99337 11.8947 6.99337 11.6867 7.01989C10.8375 7.12813 10.1408 7.8311 8.74731 9.23703L7 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17L15.2527 15.237C13.8592 13.8311 13.1625 13.1281 12.3133 13.0199C12.1053 12.9934 11.8947 12.9934 11.6867 13.0199C10.8375 13.1281 10.1408 13.8311 8.74731 15.237L7 17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportNodeLabel);
export default __webpack_public_path__ + "static/media/export-node-label.1dfda71d3adfdf5dcb64ad0af194d4ca.svg";
export { ForwardRef as ReactComponent };